import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';

const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));

function Dot({ ok, warn, neutral }) {
  const c = neutral ? 'var(--line)' : ok ? 'var(--ok)' : warn ? 'var(--warn)' : 'var(--err)';
  return <span style={{ width: 10, height: 10, borderRadius: '50%', background: c, display: 'inline-block', boxShadow: `0 0 0 3px ${c}22` }} />;
}

// rileva i problemi reali (semaforo): mongo, disco, licenza, agenti in standby/disservizio, quota SSMATE, errori 456
function rilevaProblemi(s, a456, acop, assm, agea, aind) {
  const P = [];
  if (!s.mongo_ok) P.push({ lvl: 'critico', msg: 'MongoDB non raggiungibile' });
  const dRec = s.disco?.recordings;
  if (dRec?.used_pct >= 95) P.push({ lvl: 'critico', msg: `Disco registrazioni quasi pieno (${dRec.used_pct}%)` });
  else if (dRec?.used_pct >= 90) P.push({ lvl: 'warn', msg: `Disco registrazioni in esaurimento (${dRec.used_pct}%)` });
  if (!s.licenza?.file_presente && s.licenza?.enforce) P.push({ lvl: 'critico', msg: 'Licenza assente (enforce attivo)' });
  if (a456?.job?.status === 'standby') P.push({ lvl: 'warn', msg: 'AI 456 in standby (disservizio 456)' });
  if (acop?.job?.status === 'standby') P.push({ lvl: 'warn', msg: 'AI copertura in standby' });
  if (agea?.job && agea.job.total && agea.job.disservizi >= agea.job.total) P.push({ lvl: 'warn', msg: 'Portale Vodafone in disservizio' });
  if (assm?.agente_attivo && !assm?.job && (assm?.esauriti?.length > 0)) P.push({ lvl: 'warn', msg: 'AI SSMATE in attesa crediti (quota esaurita)' });
  if (aind?.job?.standby) P.push({ lvl: 'warn', msg: 'AI Indaga in standby (possibile blocco Google)' });
  const nu = s.numeri || {};
  if (nu.errore != null) {
    const validi = (nu.tim || 0) + (nu.non_tim || 0) + nu.errore;
    const rate = validi ? nu.errore / validi : 0;
    if (nu.errore >= 20 && rate >= 0.05) P.push({ lvl: 'warn', msg: `Tasso errori 456 alto (${Math.round(rate * 100)}%)` });
  }
  return P;
}

function Row({ label, children }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', borderBottom: '1px solid var(--surface-2)', fontSize: 13 }}>
      <span style={{ flex: 1, color: 'var(--muted)' }}>{label}</span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{children}</span>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 14, padding: 16, flex: '1 1 320px' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: 14 }}>{title}</h3>
      {children}
    </div>
  );
}

export default function SalutePage() {
  const [s, setS] = useState(null);
  const [a456, setA456] = useState(null);
  const [acop, setAcop] = useState(null);
  const [assm, setAssm] = useState(null);
  const [agea, setAgea] = useState(null);
  const [aind, setAind] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/salute`).then(r => setS(r.data)).catch(() => {});
  }, []);
  const loadAgenti = useCallback(() => {
    axios.get(`${API}/agent/status`).then(r => setA456(r.data)).catch(() => {});
    axios.get(`${API}/copertura/stato`).then(r => setAcop(r.data)).catch(() => {});
    axios.get(`${API}/ssmate/bulk/preview`).then(r => setAssm(r.data)).catch(() => {});
    axios.get(`${API}/gea/stato`).then(r => setAgea(r.data)).catch(() => {});
    axios.get(`${API}/indaga/stato`).then(r => setAind(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load(); loadAgenti();
    const t1 = setInterval(load, 8000);
    const t2 = setInterval(loadAgenti, 5000);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, [load, loadAgenti]);

  if (!s) return <div style={{ padding: 24, color: 'var(--muted)' }}>Caricamento…</div>;

  const job456 = a456?.job;
  const jobCop = acop?.job;
  const dRec = s.disco?.recordings;
  const dExp = s.disco?.exports;
  const diskWarn = dRec && dRec.used_pct != null && dRec.used_pct >= 90;
  const problemi = rilevaProblemi(s, a456, acop, assm, agea, aind);
  const critico = problemi.some((p) => p.lvl === 'critico');

  return (
    <div style={{ padding: 20, maxWidth: 1050, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, margin: '0 0 4px' }}>🩺 Salute sistema</h1>
      <p style={{ margin: '0 0 14px', color: 'var(--muted)', fontSize: 13 }}>
        Diagnostica a colpo d'occhio · ora server {new Date(s.ora).toLocaleString('it-IT')}
      </p>

      {/* Semaforo: tutto ok oppure elenco problemi */}
      <div style={{
        marginBottom: 16, borderRadius: 12, padding: '12px 16px',
        background: problemi.length === 0 ? 'rgba(34,197,94,0.10)' : critico ? 'rgba(239,68,68,0.10)' : 'rgba(234,179,8,0.12)',
        border: `1px solid ${problemi.length === 0 ? 'rgba(34,197,94,0.35)' : critico ? 'rgba(239,68,68,0.4)' : 'rgba(234,179,8,0.45)'}`,
      }}>
        {problemi.length === 0 ? (
          <b style={{ color: 'var(--ok)', fontSize: 14 }}>✅ Tutto regolare</b>
        ) : (
          <>
            <b style={{ color: critico ? 'var(--err)' : 'var(--warn)', fontSize: 14 }}>
              ⚠️ {problemi.length} {problemi.length === 1 ? 'problema rilevato' : 'problemi rilevati'}
            </b>
            <ul style={{ margin: '8px 0 0', paddingLeft: 18, fontSize: 13 }}>
              {problemi.map((p, i) => (
                <li key={i} style={{ color: p.lvl === 'critico' ? 'var(--err)' : 'var(--warn)', marginBottom: 2 }}>{p.msg}</li>
              ))}
            </ul>
          </>
        )}
      </div>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
        <Card title="Stato">
          <Row label="MongoDB"><Dot ok={s.mongo_ok} /> {s.mongo_ok ? `connesso (${s.db})` : 'NON raggiungibile'}</Row>
          <Row label="AI 456">
            <Dot ok={!!a456?.running && !a456?.in_attesa} warn={a456?.attivo && (a456?.in_attesa || !a456?.running)} neutral={!a456?.attivo} />
            {a456?.in_attesa ? 'in attesa di record' : a456?.running ? 'in esecuzione' : a456?.attivo ? 'acceso' : 'spento'}
          </Row>
          <Row label="AI copertura">
            <Dot ok={!!jobCop} warn={s.agente_copertura && !jobCop} neutral={!s.agente_copertura} />
            {jobCop ? 'in esecuzione' : s.agente_copertura ? 'acceso (in attesa)' : 'spento'}
          </Row>
          <Row label="AI SSMATE">
            <Dot ok={!!assm?.job} warn={assm?.agente_attivo && !assm?.job} neutral={!assm?.agente_attivo} />
            {assm?.job ? 'in esecuzione' : assm?.agente_attivo ? (assm?.esauriti?.length ? 'in attesa crediti' : 'acceso (in attesa)') : 'spento'}
          </Row>
          <Row label="AI VF (Vodafone)">
            <Dot ok={!!agea?.job} warn={agea?.agente_attivo && !agea?.job} neutral={!agea?.agente_attivo} />
            {agea?.job ? 'in esecuzione' : agea?.agente_attivo ? 'acceso (in attesa)' : (agea?.abilitata === false ? 'disabilitato' : 'spento')}
          </Row>
          <Row label="AI Indaga">
            <Dot ok={!!aind?.job && !aind?.in_attesa} warn={aind?.agente_attivo && (!aind?.job || aind?.in_attesa)} neutral={!aind?.agente_attivo} />
            {aind?.job ? 'in esecuzione'
              : aind?.agente_attivo ? (aind?.in_attesa ? (aind?.motivo_attesa || 'in attesa') : 'acceso (in attesa)')
              : (aind?.abilitata === false ? 'disabilitato' : 'spento')}
          </Row>
          <Row label="Licenza">
            <Dot ok={s.licenza?.file_presente} warn={!s.licenza?.enforce} />
            {s.licenza?.file_presente ? 'attiva' : 'assente'}{s.licenza?.enforce ? ' · enforce ON' : ' · enforce OFF'}
          </Row>
        </Card>

        <Card title="Numeri">
          <Row label="Totale"><b>{nf(s.numeri.total)}</b></Row>
          <Row label="In attesa">{nf(s.numeri.pending)}</Row>
          <Row label="Da ri-verificare (scaduti)">{nf(s.numeri.scaduti)}</Row>
          <Row label="Esportabili">{nf(s.numeri.esportabili)}</Row>
          <Row label="In blacklist">{nf(s.numeri.blacklist)}</Row>
        </Card>
      </div>

      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
        <Card title="SIP / Trascrizione">
          <Row label="Modalità SIP">{s.sip.use_builtin ? 'Integrato (PJSUA2)' : 'MicroSIP'}</Row>
          <Row label="Linee configurate"><b>{nf(s.sip.linee)}</b></Row>
          <Row label="Whisper">{s.whisper.model || '—'} · {s.whisper.device || '—'}</Row>
          {job456 && job456.per_line && Object.keys(job456.per_line).length > 0 && (
            <Row label="Linee registrate (job)">{nf(a456?.n_linee_attive)}</Row>
          )}
        </Card>

        <Card title="Disco">
          <Row label="Registrazioni (free / tot)">
            <Dot ok={!diskWarn} warn={diskWarn} />
            {dRec ? `${nf(dRec.free_gb)} / ${nf(dRec.total_gb)} GB (${dRec.used_pct}%)` : '—'}
          </Row>
          <Row label="File registrazioni">{nf(s.disco?.recordings_files)}</Row>
          {dExp && <Row label="Export (free / tot)">{`${nf(dExp.free_gb)} / ${nf(dExp.total_gb)} GB`}</Row>}
        </Card>

        <Card title="Servizi">
          <Row label="Copertura TIM"><Dot ok={s.copertura_abilitata} warn={!s.copertura_abilitata} /> {s.copertura_abilitata ? 'abilitata' : 'disabilitata'}</Row>
          <Row label="Notifiche email"><Dot ok={s.notifiche} warn={!s.notifiche} /> {s.notifiche ? 'attive' : 'spente'}</Row>
          <Row label="Report automatico"><Dot ok={s.report} warn={!s.report} /> {s.report ? 'attivo' : 'spento'}</Row>
        </Card>

        <Card title="Agente Indaga (completa indirizzi)">
          <Row label="Stato">
            <Dot ok={!!aind?.job && !aind?.in_attesa} warn={aind?.agente_attivo && (!aind?.job || aind?.in_attesa)} neutral={!aind?.agente_attivo} />
            {aind?.job ? 'in esecuzione'
              : aind?.agente_attivo ? (aind?.in_attesa ? (aind?.motivo_attesa || 'in attesa') : 'acceso (in attesa)')
              : (aind?.abilitata === false ? 'disabilitato' : 'spento')}
          </Row>
          <Row label="Completabili ora"><b>{nf(aind?.eligibili)}</b></Row>
          <Row label="Tetto giornaliero">{nf(aind?.tetto)}</Row>
          {aind?.job && <Row label="Avanzamento (oggi)">{nf(aind.job.completed)}/{nf(aind.job.total)}</Row>}
          {aind?.job && <Row label="Completati / non confermati">{nf(aind.job.completati)} / {nf(aind.job.non_confermati)}</Row>}
          {aind?.job && <Row label="Non trovati / errori">{nf(aind.job.non_trovati)} / {nf(aind.job.errori)}</Row>}
        </Card>
      </div>

      {(job456 || jobCop) && (
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          {job456 && (
            <Card title="Job 456 in corso">
              <Row label="Avanzamento">{nf(job456.completed)}/{nf(job456.total)}</Row>
              <Row label="Stato">{job456.status === 'standby' ? <b style={{ color: 'var(--warn)' }}>STANDBY</b> : job456.status}</Row>
              <Row label="Velocità">{nf(a456?.velocita_min)}/min</Row>
            </Card>
          )}
          {jobCop && (
            <Card title="Job copertura in corso">
              <Row label="Avanzamento">{nf(jobCop.completed)}/{nf(jobCop.total)}</Row>
              <Row label="Stato">{jobCop.status === 'standby' ? <b style={{ color: 'var(--warn)' }}>STANDBY</b> : jobCop.status}</Row>
              <Row label="Velocità">{nf(jobCop.velocita_min)}/min</Row>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}
